import { render } from "./batchUpdateNumModel.vue?vue&type=template&id=a6776814"
import script from "./batchUpdateNumModel.vue?vue&type=script&lang=js"
export * from "./batchUpdateNumModel.vue?vue&type=script&lang=js"

import "./batchUpdateNumModel.vue?vue&type=style&index=0&id=a6776814&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__